import React, { useContext, useEffect, useRef, useState } from 'react'
import { getImages } from '../components/Common/const'
import Fancybox from '../components/Common/Fancybox'
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import Slider from "react-slick";
import { Field, Form, Formik } from 'formik';
import ValidationError from '../components/Errors/ValidationError';
import { VehicleContext } from '../components/Context/VehicleContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const vdpList = [
    "Clean CARFAX. Grigio Hati Metallic Optional Stitching",
    "Blue Calipers",
    "Active Cruise Control",
    "Advanced 3D Bang & Olufsen Sound System",
    "Blu Cepheus Seatbelts",
    "Full Leather Heated Sport Steering Wheel",
    "Panoramic Roof",
    "Privacy Glass Acoustic & Heat Insulated",
    "Steering Wheel Stitching",
    "Unicolor Alcantara Seat Upholstery",
    "Wheels: 23 Pelope Shiny Black. 2023 {vehicleData.make} {vehicleData.model}",
    "Performante AWD 8-Speed Automatic 4.0L V8 Twin Turbocharged."
];
const Vdp = () => {
    const [vehicleVIN,setVehicleVIN] = useState("");

    const { getVehicleData, vehiclesByVIN, vehicleVINsbyID, numberFormatter, priceFormatter, submitContactForm } = useContext(VehicleContext);

    const location = useLocation();
    const navigate = useNavigate();
    console.log("location", location)
    console.log("vehiclesByVIN", vehiclesByVIN)
    console.log("vehicleVIN", vehicleVIN)
    //console.log("vehicleVINsbyID", vehicleVINsbyID)
    useEffect(() => {
        if(location && !vehicleVIN && vehiclesByVIN) {
            let vin = location.pathname.slice(location.pathname.lastIndexOf("-") + 1 , location.pathname.length);
            if(vin in vehiclesByVIN) setVehicleVIN(vin);
            else if(vin in vehicleVINsbyID) {
                console.log("found vehicle ID",vin,vehicleVINsbyID[vin],vehicleVINsbyID);
                setVehicleVIN(vehicleVINsbyID[vin]);
            } else navigate("/cars-for-sale-boerne-tx");

            console.log("vin test",vin);
        }
    }, [location, vehiclesByVIN]);

    /*const defaultVehicleData = {
        exterior_color: "Gray",
        interior_color: "Rosso Ferrari",
        mileage: 2201,
        options_msrp: "42135",
        post_settings: null,
        price: "329000",
        stockno: "1017",
        tol: 23,
        year: 2021,
        make: "Ferrari",
        model: "812 GTS",
        trim: "Base",
        vdp_hero_image: getImages('new/hero-img.webp'),
        vehicle_name: "2018 Ferrari 488 Spider",
        description: `This one of a kind machine  clocks 0 - 60 in 4.5 seconds only one previous owner and only 600 have ever been made.  Its the perfect perfect piece for any collector lorem ipsum dolor sit amet, adipiscing elit, duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. sed dompor aliqua…  <a href="#">Read more</a>`,
        vin: "ZFF97CMA4M0261467",
        body_style: "2D Convertible",
        images: [getImages('new/vdp-thumb1.webp'), getImages('new/vdp-thumb2.webp'), getImages('new/vdp-thumb3.webp'), getImages('new/vdp-thumb4.webp'), getImages('new/vdp-thumb5.webp'), getImages('new/vdp-thumb6.webp')],
        gallery_images: [[getImages('new/vdp-thumb1.webp'), getImages('new/vdp-thumb2.webp')], [getImages('new/vdp-thumb3.webp'), getImages('new/vdp-thumb4.webp')], [getImages('new/vdp-thumb5.webp'), getImages('new/vdp-thumb6.webp')]]

    };*/

    const [vehicleData, setVehicleData] = useState({});
    console.log("vehicleData", vehicleData)
    const [vehicleExist, setVehicleExist] = useState(false);

    useEffect(() => {
        getVehicleData();
    }, [])

    useEffect(() => {
        if (vehicleVIN && vehiclesByVIN && vehicleVIN in vehiclesByVIN) {
            var vehicle_data = vehiclesByVIN[vehicleVIN];
            console.log(vehicle_data);
            const split_index = Math.ceil((vehicle_data.images.length - 1) / 2);

            if (split_index > 0) {
                //var gallery_images = vehicle_data.images.slice(1).reduce(function (rows, key, index) {
                //    return (index % 2 == 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) && rows;
                //}, []);
                console.log(vehicle_data.images.length - 1, split_index);
                var gallery_images = vehicle_data.images.slice(1).reduce(function (rows, key, index) {
                    return (index < split_index || vehicle_data.images.length - 1 <= 3 ? rows.push([key]) : rows[index - split_index].push(key)) && rows;
                }, []);
                vehicle_data.gallery_images = gallery_images;
            } else
                vehicle_data.gallery_images = vehicle_data.images.slice(1);
            console.log(vehicle_data);
            setVehicleData(vehicle_data);
            setVehicleExist(true);
        }
    }, [vehicleVIN, vehiclesByVIN]);

    var srpCarSlider = {
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
        dots: true,
    };
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const handleCopy = () => {
        const textArea = document.createElement('textarea');
        textArea.value = vehicleData.vin;
        textArea.style.position = 'absolute';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand('copy');
            showTooltip();
        } catch (err) {
            console.error('Failed to copy text:', err);
        }
        document.body.removeChild(textArea);
    };
    const showTooltip = () => {
        setTooltipVisible(true);
        setTimeout(() => {
            setTooltipVisible(false);
        }, 2000);
    };

    // Mobile view condition
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const [showAll, setShowAll] = useState(false);
    const visibleItems = showAll ? vehicleData?.descriptions : vehicleData?.descriptions?.slice(0, 6);
    const galleryRef = useRef(null);
    const openGallery = () => {
        const flatImages = vehicleData?.gallery_images?.flat();
        const items = flatImages.map((src) => ({ src, type: "image" }));

        NativeFancybox.show(items);
    };
    const sectionRef = useRef(null);
    const scrollToSection = () => {
        sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };
    return (
        <>
            {vehicleExist ?
                <>
                    <section className='vdp-wrap'>
                        <div className='container mxw-1366'>
                            <div className='custom-breadcrumb mb-4 mt-3'>
                                <nav style={{ "--bs-breadcrumb-divider": "'>'" }} aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/cars-for-sale-boerne-tx">Collections</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">{vehicleData.make}</li>
                                    </ol>
                                </nav>
                            </div>
                            <section className='vdp-banner-wrap mt-0'>
                                <div className='d-flex vdp-banner-flex align-items-center'>
                                    <div className='w-50 mt-3 wow fadeInLeft' data-wow-delay="0.2s">
                                        {vehicleData.vdp_hero_image ? 
                                            <img src={vehicleData.vdp_hero_image} alt='hero' />
                                            : 
                                            <img src={getImages('vdp_top_coming_soon.webp')} alt='coming soon' />
                                        }
                                    </div>
                                    <div className='w-50 pe-4 wow fadeInRight' data-wow-delay="0.4s">
                                        <div className='d-flex align-items-center mb-4 brand-flex'>
                                            <div className='brand-logo'>
                                                <img src={getImages(`logos/${vehicleData.make}.png`)} />
                                            </div>
                                            <div className='brand-name ps-3 text-uppercase'>
                                                {vehicleData.make}
                                            </div>
                                        </div>
                                        <div className='d-flex justify-content-between vdp-banner-info'>
                                            <div>
                                                <div className='vdp-md-title mb-xl-4 mb-md-2 pe-md-3'>{vehicleData.year} {vehicleData.model} <span className='vdp-trim'>{vehicleData.trim}</span></div>
                                                <div className='d-flex align-items-center justify-content-between'>
                                                    <div className='d-xl-flex align-items-center'>
                                                        <div className='mb-md-2 mb-xl-0'>
                                                            <span className='location-tag'><img src={getImages('pin-icon.svg')} /> {vehicleData.location}</span>
                                                        </div>
                                                        <div className='sm-title mob-vdp-miles ps-md-4'>Miles: {numberFormatter(vehicleData.mileage,false,false)}</div>
                                                    </div>
                                                    <div className='d-md-none'>
                                                        <div className='d-inline-flex align-items-center mb-3 mb-4 price-sec2 mob-price-sec2'>
                                                            <span className='xs-title pe-md-2'>Price</span>
                                                            <span className='vdp-lg-title'>{priceFormatter(vehicleData.price, true)}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='text-end'>
                                                <div className='d-inline-flex align-items-center d-none d-md-block mb-4 price-sec2'>
                                                    <span className='xs-title pe-2'>Price</span>
                                                    <span className='vdp-lg-title'>{priceFormatter(vehicleData.price, true)}</span>
                                                </div>
                                                <div className='pt-md-2'>
                                                    <button className='btn-black-theme inquire-btn text-white' type='button' onClick={scrollToSection}>Inquire</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            {vehicleData?.descriptions?.length > 0 &&
                                <section className='vdp-list-wrap'>
                                        {isMobile ?
                                            <div className='vdpl-flex wow fadeInUp' data-wow-delay="0.6s">
                                                <ul className="vdp-list">
                                                    {visibleItems.map((item, index) => (
                                                        <li key={index}>{item}</li>
                                                    ))}
                                                </ul>
                                                {/* {!showAll && ( */}
                                                <button className="view-more-btn" onClick={() => setShowAll(!showAll)}>
                                                    {!showAll ? 'View More' : 'View Less'}
                                                </button>
                                                {/* )} */}
                                            </div>
                                            :
                                            <div className='d-flex vdpl-flex vdpl-desktop-flex wow fadeInUp' data-wow-delay="0.6s">
                                                <ul className='vdp-list'>
                                                    {vehicleData.descriptions.filter((item, index) => index < vehicleData.descriptions.length / 2).map((item, index) => (
                                                        <li key={index}>{item}</li>
                                                    ))}
                                                </ul>
                                                <ul className='vdp-list'>
                                                    {vehicleData.descriptions.filter((item, index) => index >= vehicleData.descriptions.length / 2).map((item, index) => (
                                                        <li key={index}>{item}</li>
                                                    ))}
                                                </ul>
                                            </div>}
                                </section>
                            }
                        </div>
                        {vehicleData.gallery_images.length > 0 &&
                            <section className='vdp-gallery-wrap'>
                                <div className='container mxw-1366'>
                                    <div className='vdp-gallery-tab wow fadeInUp' data-wow-delay="0.3s">
                                        <Fancybox
                                            options={{
                                                Carousel: {
                                                    infinite: false,
                                                },
                                            }}
                                        >
                                            {isMobile ?
                                                <div className='row g-3'>
                                                    {vehicleData.gallery_images.slice(0, 3).map((v, i) => {
                                                        return v.map((w, j) => {
                                                            const uniqueKey = `${i}-${j}`;
                                                            return (
                                                                <div className='col-6' key={uniqueKey}>
                                                                    <div className='gallery-box'>
                                                                        <a
                                                                            data-fancybox="gallery_1"
                                                                            ref={i === 0 && j === 0 ? galleryRef : null}
                                                                            href={w}
                                                                            className='position-relative'
                                                                        >
                                                                            <img src={w} alt='thumb' onError={(e) => { e.target.src = getImages("vdp_coming_soon.webp") }} />
                                                                            {/* onError={(e) => { e.target.src = getImages("vdp_coming_soon.webp") }} */}
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            );
                                                        });
                                                    })}

                                                    <div className='col-12 text-center mt-4'>
                                                        <button type='button' className='photo-count'
                                                            onClick={openGallery}
                                                        ><img src={getImages('photo-camera-icon.png')} /> {vehicleData.gallery_images.flat().length}+</button>
                                                    </div>
                                                </div>
                                                : <Slider className="gallery-slider common-arrow" {...srpCarSlider}>
                                                    {vehicleData.gallery_images.map((v, i) => {
                                                        return (
                                                            <div className='item' key={i}>
                                                                {v.map((w, j) => {
                                                                    return (
                                                                        <div className='gallery-box mb-4' key={j}>
                                                                            <a data-fancybox="gallery" href={w} className='position-relative'>
                                                                                <img src={w} alt='thumb' onError={(e) => { e.target.src = getImages("vdp_coming_soon.webp") }} />
                                                                            </a>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        );
                                                    })}
                                                </Slider>}
                                        </Fancybox>
                                    </div>
                                </div>
                            </section>
                        }
                    </section>
                    <section className='vdp-content-wrap'>
                        <div className='container mxw-1366'>
                            <div className='vdpa-block mt-5 row'>
                                <div className='col-lg-4 order-lg-2 mb-3 mb-lg-0'>
                                    <div className='vdpa-box p-4'>
                                        <div className='md-title text-uppercase mb-3 wow fadeInUp' data-wow-delay="0.2s">Vehicle Info</div>
                                        <div className='vdpa-table'>
                                            <table className='w-100'>
                                                <tbody>
                                                    <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                        <th>Stock</th>
                                                        <td>{vehicleData.stockno}</td>
                                                    </tr>
                                                    <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                        <th>VIN</th>
                                                        <td className="text-nowrap">
                                                            <span className='position-relative copy-info'>
                                                                <span className='copy_icon' onClick={handleCopy} style={{ cursor: 'pointer' }}></span>
                                                                {tooltipVisible && <span className='copy-tooltip'>Copied!</span>}
                                                            </span>
                                                            {vehicleData.vin}
                                                        </td>
                                                    </tr>
                                                    <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                        <th>Year</th>
                                                        <td>{vehicleData.year}</td>
                                                    </tr>
                                                    <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                        <th>Make</th>
                                                        <td>{vehicleData.make}</td>
                                                    </tr>
                                                    <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                        <th>Model</th>
                                                        <td>{vehicleData.model}</td>
                                                    </tr>
                                                    <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                        <th>Trim</th>
                                                        <td>{vehicleData.trim}</td>
                                                    </tr>
                                                    <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                        <th>Mileage</th>
                                                        <td>{numberFormatter(vehicleData.mileage,false,false)}</td>
                                                    </tr>
                                                    <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                        <th>Body Style</th>
                                                        <td>{vehicleData.body_style}</td>
                                                    </tr>
                                                    <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                        <th>Exterior Color</th>
                                                        <td>{vehicleData.exterior_color}</td>
                                                    </tr>
                                                    <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                        <th>Interior Color</th>
                                                        <td>{vehicleData.interior_color}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className='mt-4 mb-2 wow fadeInUp' data-wow-delay="0.2s">
                                            <div className='text-center'>
                                                <a href={'http://www.carfax.com/VehicleHistory/p/Report.cfx?partner=DVW_1&vin=' + vehicleData.vin} target="_blank">
                                                    <img src={getImages('carfax-tag.jpg')} alt='carfax' />
                                                    {/*<img src='http://www.carfaxonline.com/assets/subscriber/showmethecarfax.jpg' width='155' height='56' border='0' />*/}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-8'>
                                    <div className='vdpa-box vdpa-about-box'>
                                        <div id="gotAQuestion" ref={sectionRef} >
                                            <div className='md-title mt-2 pt-5 mb-90 wow fadeInUp' data-wow-delay="0.6s">Got a question? <a href="#" className='text-theme'>Call</a> or <a href="#" className='text-theme'>Chat</a> live with a sales representative</div>
                                            <Formik
                                                // validationSchema={validationSchema}
                                                initialValues={{
                                                    full_name: '',
                                                    email: '',
                                                    phone: '',
                                                    comment: '',
                                                    vin: vehicleData.stockno,
                                                    year: vehicleData.year,
                                                    make: vehicleData.make,
                                                    model: vehicleData.model,
                                                    trim: vehicleData.trim,
                                                    mileage: vehicleData.mileage,
                                                    exterior: vehicleData.exterior_color,
                                                    location: vehicleData?.location || 'Boerne, TX'
                                                }}
                                                onSubmit={async (values, { resetForm }) => {
                                                    console.log(values);
                                                    const data = await submitContactForm(values);
                                                    if (data.success) {
                                                        resetForm();
                                                        navigate("/thank-you");
                                                    } else
                                                        alert("There was a problem with your submission");
                                                }}
                                            >
                                                {({ values, setFieldValue, field, form }) => (
                                                    <Form className="custom-form" autoComplete="off" name="contact-form">
                                                        <Field type="hidden" name="vin" value={values.vin}/>
                                                        <Field type="hidden" name="year" value={values.year} />
                                                        <Field type="hidden" name="make" value={values.make} />
                                                        <Field type="hidden" name="model" value={values.model} />
                                                        <Field type="hidden" name="trim" value={values.trim} />
                                                        <Field type="hidden" name="mileage" value={values.mileage} />
                                                        <Field type="hidden" name="exterior" value={values.exterior_color} />
                                                        <Field type="hidden" name="location" value={values.location} />
                                                        <div className='row'>
                                                            <div className='col-md-6 wow fadeInUp' data-wow-delay="0.2s">
                                                                <div className='form-group'>
                                                                    <div className='d-flex align-items-center justify-content-between mb-2'>
                                                                        <div className='cs-label'>Full Name</div>
                                                                        <div className='cs-require'>* Required</div>
                                                                    </div>
                                                                    <Field
                                                                        type="text"
                                                                        name="full_name"
                                                                        className="form-control"
                                                                        required />
                                                                    <ValidationError name="full_name" />
                                                                </div>
                                                                <div className='form-group'>
                                                                    <div className='d-flex align-items-center justify-content-between mb-2'>
                                                                        <div className='cs-label'>Email</div>
                                                                        <div className='cs-require'>* Required</div>
                                                                    </div>
                                                                    <Field
                                                                        type="text"
                                                                        name="email"
                                                                        className="form-control"
                                                                        required />
                                                                    <ValidationError name="email" />
                                                                </div>
                                                                <div className='form-group'>
                                                                    <div className='cs-label mb-2'>Phone Number</div>
                                                                    <Field
                                                                        type="text"
                                                                        name="phone"
                                                                        className="form-control"
                                                                        required />
                                                                    <ValidationError name="phone" />
                                                                </div>
                                                            </div>
                                                            <div className='col-md-6 wow fadeInUp' data-wow-delay="0.4s">
                                                                <div className='form-group'>
                                                                    <div className='cs-label mb-2'>Comments</div>
                                                                    <Field
                                                                        type="text"
                                                                        name="comment"
                                                                        className="form-control h-218"
                                                                        component="textarea" />
                                                                    <ValidationError name="comment" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='row mt-3 justify-content-between about-action-flex wow fadeInUp' data-wow-delay="0.6s">

                                                            <div className='col-md-6 text-end order-md-2'>
                                                                <button className='btn-theme lg-btn w-300'>Send</button>
                                                            </div>
                                                            <div className='col-md-6 fb-contact-info'>
                                                                <a href='tel:8309815050' className='d-flex align-items-center phone-no-text mb-2'>
                                                                    <span className='fw-400 mnw-150'><span className='call-icon'><img src={getImages('call.png')} alt='call' /></span> Boerne:</span>
                                                                    <span>830-981-5050</span>
                                                                </a>
                                                                <a href='tel:8309815050' className='d-flex align-items-center phone-no-text mb-3'>
                                                                    <span className='fw-400 mnw-150'><span className='call-icon'><img src={getImages('call.png')} alt='call' /></span> Austin:</span>
                                                                    <span>512-233-7800</span>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </Form>
                                                )}
                                            </Formik>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='text-center ab-logo'>
                                <img src={getImages('mm-logo-white.webp')} />
                            </div>
                        </div>
                    </section>
                </>
                :
                <section className='vdp-wrap mnh-90vh'></section>
            }
        </>
    )
}

export default Vdp